import React, { useState, useEffect } from "react";
import {Modal, Table, Input, notification} from "antd";
import _ from "i18n";
import {connect} from "react-redux";
import {setFilteredDoublePaymentItems} from "../../../actions/actions.js";
import {formatAmount} from "utils";
import moment from "moment";
import {
  getDoublePayment,
  refundWithMangoPay,
  removeDoublePaymentFromDatatable,
  changeOrdersRefundStatus, changeRefundedOrderStatus
} from "../../../actions/thunks";
import {ExclamationCircleOutlined} from "@ant-design/icons";


const { Search } = Input;

const openNotificationWithIcon = (type, description, message) => {
  notification[type]({
    message: message,
    description:
    description,
    style: {
      marginTop: 120,
    },
  });
};

const DoublePayment = ({
  statisticsFilter,
  doublePaymentReducer,
  auth,
  getDoublePayment,
  setFilteredDoublePaymentItems,
  refundWithMangoPay,
  removeDoublePaymentFromDatatable,
  changeOrdersRefundStatus,
  changeRefundedOrderStatus,
  openFeedMangoModal
}) => {

  const [search, setSearch] = useState('');
  const [showSpinner, setShowSpinner] = useState(false);
  const [isRefundLoading, setIsRefundLoading] = useState(false);
  const [selectedOrderIds, setSelectedOrderIds] = useState([]);
  
  const columns = [
      {
        title: _("credit-note-number"),
        dataIndex: "officialNumber",
        align: "left",
        width:65,
      },

      {
        title: _("vcs"),
        dataIndex: "vcs",
        align: "left",
        width:101,

      },


      {
        title: _("user-email"),
        align: "left",
        dataIndex: "user.mainEmail",
        width:200,

      },


      {
        title: _("organization"),
        dataIndex: "clientOrganization",
        align: "left",
        width:125,

      },


      {
        title: _("amount"),
        dataIndex: "includingVatAmount",
        align: "center",
        width:56,

        render: amount => formatAmount(amount)
      },

      {
        title: _("first-payment"),
        dataIndex: "",
        align: "center",

        render: (text, record) => {

          let assignments = record.payments && record.payments.length > 0 ? record.payments : [];

          let assignment = assignments[0];

          if(assignment.operationType) {
            return (<div> {_(assignment.operationType)}</div>)
          } else {
            return (<div> --- </div>)

          }

        }
      },

      {
        title: _("date-first-payment"),
        dataIndex: "",
        align: "center",

        render: (text, record) => {

          let assignments = record.payments && record.payments.length > 0 ? record.payments : [];

          let assignment = assignments[0];

          if(assignment.dateTimeAssignment) {
            return (<div> {moment(assignment.dateTimeAssignment).format("YYYY-MM-DD")}</div>)
          } else {
            return (<div> --- </div>)

          }

        }
      },

      {
        title: _("second-payment"),
        dataIndex: "",
        align: "center",

        render: (text, record) => {

          if(record.doublePayment) {
            return (<div> {_('BANK_TRANSFER')}</div>)
          } else {
            return (<div> --- </div>)
          }

        }
      },


      {
        title: _("date-second-payment"),
        dataIndex: "",
        align: "center",

        render: (text, record) => {

          if(record.doublePayment && record.doublePayment.creationDate) {
            return (<div> {record.doublePayment.creationDate}</div>)
          } else {
            return (<div> --- </div>)

          }

        }
      },

      {
        title: _("payment-account"),
        dataIndex: "",
        align: "left",

        render: (text, record) => {

          if(record.doublePayment && record.doublePayment.counterPartAccount) {
            return(
            <div> {record.doublePayment.counterPartAccount}</div>
            )
          } else {
            return (<div> --- </div>)
          }

        }
      },
      {
        title: _("REFUNDED_WITH_BANK_TRANSFER"),
        dataIndex: "",
        align: "center",

        render: (text, record) => {

          if(record.refundByBankTransferStatus == "PENDING") return _('Pending');

          return _('no');

        }
      },
      {
        title: "",
        dataIndex: "",
        align: "center",

        render: (text, record) => {

          let canMangoRefund = false;
          for (let i = 0; i < record.payments.length; i++) {
            if(record.payments[i].operationType === 'MANGO_PAY'){
              canMangoRefund = true
              break
            }
          }

          if (canMangoRefund === false || record.refundByBankTransferStatus == "PENDING") return null;

          return(
            <div className={selectedOrderIds.includes(record.id) ? "cursor-not-allowed" : ""}>
              <button type={'button'} className={"double-payment-refund-button" + (selectedOrderIds.includes(record.id) ? " disabled" : "")} onClick={() => showConfirmModal(record.id, record.includingVatAmount)}>{_("refund")}</button>
            </div>
          )

        }
      },

    ];

  useEffect(() => {
    if(statisticsFilter.apps && statisticsFilter.apps.length > 0) {
      getDoublePayment(statisticsFilter.apps && statisticsFilter.apps.length > 0 ? statisticsFilter.apps : [] , statisticsFilter.appRefs && statisticsFilter.appRefs.length > 0 ? statisticsFilter.appRefs : [], auth.currentClient ? auth.currentClient.id : null, statisticsFilter.year && statisticsFilter.year.length > 0 ? statisticsFilter.year : [], statisticsFilter.appType && statisticsFilter.appType.length > 0 ? statisticsFilter.appType : [])
    }
  },[])

  useEffect(() => {
    getDoublePayment(statisticsFilter.apps && statisticsFilter.apps.length > 0 ? statisticsFilter.apps : [] , statisticsFilter.appRefs && statisticsFilter.appRefs.length > 0 ? statisticsFilter.appRefs : [], auth.currentClient ? auth.currentClient.id : null, statisticsFilter.year && statisticsFilter.year.length > 0 ? statisticsFilter.year : [], statisticsFilter.appType && statisticsFilter.appType.length > 0 ? statisticsFilter.appType : [])
  },[statisticsFilter]);


  const calculSum = () => {
    return (notPaidInvoicesDetails.filteredItems).reduce((sum, { includingVatAmount , manual }) => {
        sum += parseInt(includingVatAmount);
        if (manual && manual.amount) {
          sum -= parseInt(manual.amount);
        }
        return sum
      }, 0
    )
  }


  const handleSearch = (value) => {
    setSearch(value);
    let results=doublePaymentReducer.items.filter((elem)=>{

      return (contains(elem.user.mainEmail,value.trim()) || contains(elem.vcs,value.trim()) || contains(elem.clientOrganization,value.trim()) || contains(elem.comment,value.trim()))
    });
    setFilteredDoublePaymentItems(results);

  };

  const contains = (name, text) => {
    if(name === null ) return;
    return (name.trim()).search(new RegExp(text, 'gi')) !== -1 || (name.trim()).search(new RegExp(text, 'gi')) === 0;
  }


  const showConfirmModal = (orderId, amountToRefund) => {

    const {confirm} = Modal;
    const onOk = () => refundWithMangoPay(orderId, amountToRefund);

    confirm({
      title: _('MANGO_REFUND_CONFIRM_TITLE'),
      icon: <ExclamationCircleOutlined/>,
      okText: _("confirm"),
      cancelText: _("cancel"),
      className: 'relanceActivationModal',
      onOk,
    });

  };

  const refundWithMangoPayHandler = (orderId, amountToRefund) => {

    setIsRefundLoading(true);
    refundWithMangoPay(orderId, 0, null).then((res) => {

      if(res.status == 200 || (res.data && res.data.statusCode == 200)){
        removeDoublePaymentFromDatatable(orderId);
        openNotificationWithIcon('success', _('success-save-iban-bic'), _('successfulAction'));
        setIsRefundLoading(false)
      } else {
        openNotificationWithIcon('error', _('errorOccured'), _('error'));
        setIsRefundLoading(false)
      }
    }).catch((err) => {
      setIsRefundLoading(false)
      if(err.response.data.errors.code == 402){
        showFeedMangoConfirmModal(err.response.data.errors.balance, orderId, amountToRefund);
      } else {
        openNotificationWithIcon('error', _('errorOccured'), _('error'));
      }
    })

  };

  const showConfirmModalForManualRefund = (orderIds) => {

    const {confirm} = Modal;
    const onOk = () => changeOrdersRefundStatus(orderIds);

    confirm({
      title: _('CONFIRMATION_MESSAGE'),
      icon: <ExclamationCircleOutlined/>,
      okText: _("confirm"),
      cancelText: _("cancel"),
      className: 'relanceActivationModal',
      onOk,
    });

  };

  const changeOrdersRefundStatusHandler = (orderIds) => {

    setIsRefundLoading(true);
    changeOrdersRefundStatus(orderIds).then((res) => {

      if(res.status == 200 || (res.data && res.data.statusCode == 200)) {
        openNotificationWithIcon('success', _('success-save-iban-bic'), _('successfulAction'));
        changeRefundedOrderStatus(res.data.data);
        setIsRefundLoading(false);
        setSelectedOrderIds([]);
      } else {
        openNotificationWithIcon('error', _('errorOccured'), _('error'));
        setIsRefundLoading(false);
      }
    }).catch((err) => {
      openNotificationWithIcon('error', _('errorOccured'), _('error'));
      setIsRefundLoading(false);
    })

  };

  const showFeedMangoConfirmModal = (balance, orderId, amountToRefund) => {

    const {confirm} = Modal;
    const onOk = () => openFeedMangoModal(orderId, amountToRefund);

    confirm({
      title: <div>
        <div className={'mb-1'}>{_('REFUND_FAILED') + ' ' + _('MANGO_WALLET_BALANCE') + formatAmount(balance)}</div>
        <div>{_('FEED_MANGO_WALLET_QUESTION')}</div>
      </div>,
      icon: <ExclamationCircleOutlined/>,
      okText: _("yes"),
      cancelText: _("no"),
      className: 'relanceActivationModal',
      onOk,
    });

  };

    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        setSelectedOrderIds(selectedRowKeys);
      },
      getCheckboxProps: record => ({
        disabled: record.refundByBankTransferStatus == 'PENDING',
      }),
      selectedRowKeys: selectedOrderIds,
    };

    return (
      <div className="stats-invoice-detail ">

        <div className="bg-blue-lightest h-16 modal-header-title">
          {_('double-payment')}
        </div>

        <div className="flex flex-row justify-between mt-8" >

          <div className="flex items-center justify-start mt-3">
            <div className="recap-day-title">

              {_('Total') + " : " +(isNaN(doublePaymentReducer.sum) ? formatAmount(0) : formatAmount(doublePaymentReducer.sum))}
            </div>

          </div>
          <div className="w-1/3">
            <Search
              placeholder={_('search') + "..."}
              onChange={({target: {value}}) => handleSearch(value)}
              size={"small"}
              allowClear={true}
              value={search.trim()}
            />

          </div>
        </div>

        <div className={'flex items-center'}>
          <div>{_('SELECT_REFUNDED_ORDERS')}</div>
          <div className={'ml-2' + (selectedOrderIds.length == 0 ? " cursor-not-allowed" : "")}>
            <button type={'button'} className={"double-payment-refund-button" + (selectedOrderIds.length == 0 ? " disabled" : "")} onClick={() => showConfirmModalForManualRefund(selectedOrderIds)}>{_("save")}</button>
          </div>
        </div>

        <div className="pt-4  pb-8 relative">
          <Table
            rowKey="id"
            columns={columns}
            dataSource={doublePaymentReducer.filteredItems && doublePaymentReducer.filteredItems.length > 0 ? doublePaymentReducer.filteredItems : null}
            loading={doublePaymentReducer.fetching || isRefundLoading}
            pagination={false}
            size="middle"
            className="ttp-invoice-detail-tab table-padding"
            scroll={{ x:false, y: 400 }}
            rowSelection={rowSelection}
          />
        </div>
      </div>
    );
}

const mapStateToProps = state => ({
  statisticsFilter: state.filters.statisticsFilter,
  doublePaymentReducer: state.doublePaymentReducer,
  auth: state.auth,
});

const mapDispatchToProps = {
  getDoublePayment,
  setFilteredDoublePaymentItems,
  refundWithMangoPay,
  removeDoublePaymentFromDatatable,
  changeOrdersRefundStatus,
  changeRefundedOrderStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(DoublePayment);



// WEBPACK FOOTER //
// ./app/components/Admin/statisctics/DoublePayment.js